export default "__VITE_ASSET__VkZAnw_R__"